<template lang="pug">
  .pdp-price-module.row
    .xs-12
      .xs-6.text-center.one-time-price
        p.xs-f-xsmall.lg-f-small.max-at-tweak.text-color-2
          | One Time Order
          br
          .brand-color-1.bold {{ $currency(product.price) }}

      .boxes.xs-6.text-center
        p.xs-12.xs-f-xsmall.lg-f-small.max-at-tweak.text-color-2
          |  With Subscription
          br
          .brand-color-1.bold {{ $currency(product.sub_price) }}

</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: "PdpPriceModule",

    computed: {
      ...mapState('pdp', ['product'])
    }
  };
</script>

<style scoped lang="stylus">
  .pdp-price-module
    padding 1.5em 0
    border-top 1px solid color-fog-light
    border-bottom 1px solid color-fog-light

    .one-time-price
      border-right 1px solid color-fog-light
      padding-right 1em
</style>